/* Lympha buy box — tier / subscription / cadence / gift ladder / sticky bar.
   Runs inside Horizon's <product-form-component>: we manage the hidden inputs (id, selling_plan)
   and visible prices; Horizon performs the add-to-cart and opens the cart drawer.
   Event delegation on the section root so Horizon's hydration/morph cannot detach listeners. */
(function () {
  function money(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD';
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: cur }).format(cents / 100); }
    catch (e) { return '$' + (cents / 100).toFixed(2); }
  }
  // "Every month" -> 1, "Every 3 months" -> 3. Used to match the refill cadence to the kit size.
  function planMonths(name) { var m = /(\d+)/.exec(name || ''); return m ? +m[1] : 1; }
  function bestPlanIndex(tier) {
    var plans = tier.plans || []; if (!plans.length) return 0;
    var supply = Math.max(1, Math.round((tier.days || 30) / 30));
    var best = 0, bestScore = Infinity;
    plans.forEach(function (p, i) {
      var m = planMonths(p.name);
      // prefer the longest cadence that does not out-run the supply; otherwise the closest
      var score = m <= supply ? supply - m : (m - supply) + 100;
      if (score < bestScore) { bestScore = score; best = i; }
    });
    return best;
  }
  var STATE = {};
  function state(root) {
    var id = root.dataset.sectionId;
    if (STATE[id]) return STATE[id];
    var data = JSON.parse(root.querySelector('[data-lp-data]').textContent);
    var hasPlans = data.tiers.some(function (t) { return t.plans && t.plans.length; });
    var st = { data: data, hasPlans: hasPlans, cur: data.defaultTier, planIndex: Math.max(0, data.defaultPlan), planTouched: false, mode: (data.defaultSub && hasPlans) || (data.mode === 'sub' && hasPlans) ? 'sub' : 'once' };
    if (hasPlans) st.planIndex = bestPlanIndex(data.tiers[st.cur]);
    STATE[id] = st; return st;
  }
  function render(root) {
    var st = state(root), data = st.data, tiers = data.tiers;
    var $ = function (s) { return root.querySelector(s); };
    var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
    var plan = function (t) { return (t.plans && t.plans[Math.min(st.planIndex, t.plans.length - 1)]) || null; };
    var price = function (t) { var p = plan(t); return st.mode === 'sub' && p ? p.price : t.price; };
    var t = tiers[st.cur], pl = plan(t), p = price(t);
    $$('.lp-tier').forEach(function (el, j) {
      var d = tiers[j], pj = price(d), pct = d.compare > pj ? Math.round((d.compare - pj) / d.compare * 100) : 0;
      el.classList.toggle('on', j === st.cur);
      var inp = el.querySelector('input'); if (inp) inp.checked = (j === st.cur);
      el.querySelector('[data-price]').textContent = money(pj);
      el.querySelector('[data-old]').textContent = d.compare > pj ? money(d.compare) : '';
      el.querySelector('[data-meta]').textContent = d.days + '-day supply — ' + money(Math.round(pj / d.bottles)) + ' per bottle' + (pct ? ' · save ' + pct + '%' : '');
    });
    $$('.lp-gift').forEach(function (g) { g.classList.toggle('on', st.cur >= +g.dataset.min); });
    $$('.lp-purchase label').forEach(function (l) { var i = l.querySelector('input'); var on = i && i.value === st.mode; l.classList.toggle('on', on); if (i) i.checked = on; });
    var idInput = $('input[name="id"]'); if (idInput) idInput.value = t.id;
    var planInput = $('input[name="selling_plan"]'); if (planInput) planInput.value = (st.mode === 'sub' && pl) ? pl.id : '';
    var cad = $('.lp-cadence'); if (cad) cad.hidden = !(st.mode === 'sub' && t.plans && t.plans.length > 1);
    $$('.lp-cadence button').forEach(function (b, i) { b.classList.toggle('on', i === st.planIndex); });
    var cta = $('[data-cta-text]'); if (cta) cta.textContent = (st.mode === 'sub' ? data.t.subscribe : data.t.add) + ' — ' + money(p);
    var old = $('[data-cta-old]'); if (old) old.textContent = t.compare > p ? money(t.compare) : '';
    var terms = $('[data-terms]');
    if (terms) terms.innerHTML = (st.mode === 'sub' && pl)
      ? data.t.terms_sub.replace('[kit]', t.kit).replace('[cadence]', pl.name.toLowerCase()).replace('[price]', '<b>' + money(pl.price) + '</b>').replace('[once]', money(t.price))
      : data.t.terms_once.replace('[kit]', t.kit).replace('[price]', '<b>' + money(t.price) + '</b>');
    var quiet = $('.lp-terms--quiet');
    if (quiet) quiet.style.display = (terms && terms.textContent.trim()) ? 'none' : '';
    var sticky = document.querySelector('[data-lp-sticky="' + root.dataset.sectionId + '"]');
    if (sticky) {
      sticky.querySelector('[data-stk-name]').textContent = t.title + ' — ' + money(p) + (st.mode === 'sub' && pl ? ' · ' + pl.name.toLowerCase() : '');
      sticky.querySelector('[data-stk-sub]').textContent = money(Math.round(p / t.bottles)) + ' per bottle · ' + t.ship + ' · ' + (st.mode === 'sub' ? data.t.cancel : data.t.guarantee);
      sticky.querySelector('[data-stk-cta]').textContent = st.mode === 'sub' ? data.t.subscribe : data.t.add;
    }
    var arrive = $('[data-arrive]');
    if (arrive && !arrive.textContent) { var d = new Date(), add = +(arrive.dataset.days || 3); while (add > 0) { d.setDate(d.getDate() + 1); if (d.getDay() % 6) add--; } arrive.textContent = d.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }); }
  }
  function bind(root) {
    if (root.dataset.lpBound) return; root.dataset.lpBound = '1';
    var st = state(root);
    root.addEventListener('change', function (e) {
      var el = e.target; if (!(el instanceof HTMLInputElement)) return;
      if (el.closest('.lp-tier')) { st.cur = +el.value; if (!st.planTouched) st.planIndex = bestPlanIndex(st.data.tiers[st.cur]); render(root); }
      else if (el.closest('.lp-purchase')) { st.mode = el.value; render(root); }
    });
    root.addEventListener('click', function (e) {
      var b = e.target.closest('.lp-cadence button'); if (b) { st.planIndex = Array.prototype.indexOf.call(b.parentNode.querySelectorAll('button'), b); st.planTouched = true; render(root); return; }
      var th = e.target.closest('.lp-thumbs .lp-img'); if (th) { var main = root.querySelector('[data-lp-main]'); if (main && th.dataset.src) main.src = th.dataset.src; root.querySelectorAll('.lp-thumbs .lp-img').forEach(function (x) { x.classList.toggle('on', x === th); }); }
    });
    // gifts: keep the cart's gift lines in sync with the selected tier.
    // Uses /cart/update.js with ABSOLUTE quantities (1 or 0), which both adds a missing gift and
    // caps an existing one — so firing this twice can never double a line. That matters because
    // the add-to-cart can raise both a submit and a click event. It also does not depend on a
    // Buy X Get Y discount: those never apply to subscription lines, so the gifts are priced at 0.
    var pending = 0;
    function syncGifts() {
      var updates = {};
      Array.prototype.slice.call(root.querySelectorAll('.lp-gift[data-variant]')).forEach(function (g) {
        updates[g.dataset.variant] = st.cur >= +g.dataset.min ? 1 : 0;
      });
      if (!Object.keys(updates).length) return;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates: updates })
      }).then(function () {
        var c = document.querySelector('cart-items-component');
        if (c && c.fetchCartData) c.fetchCartData();
      }).catch(function () {});
    }
    // Horizon may swallow the form submit, so wait for the kit line to land rather than trust one event.
    function afterAdd() {
      var token = ++pending, target = st.data.tiers[st.cur].id, tries = 0;
      (function poll() {
        if (token !== pending) return;
        tries++;
        fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }).then(function (c) {
          if (token !== pending) return;
          if (c.items.some(function (i) { return i.variant_id === target; })) return syncGifts();
          if (tries < 12) setTimeout(poll, 250);
        }).catch(function () {});
      })();
    }
    root.addEventListener('submit', function () { setTimeout(afterAdd, 200); });
    root.addEventListener('click', function (e) { if (e.target.closest('button[type="submit"]')) setTimeout(afterAdd, 200); });

    var sticky = document.querySelector('[data-lp-sticky="' + root.dataset.sectionId + '"]');
    if (sticky) {
      document.body.classList.add('lp-has-sticky');
      var box = root.querySelector('.lp-buy');
      if (box && 'IntersectionObserver' in window) new IntersectionObserver(function (e) { sticky.classList.toggle('show', !e[0].isIntersecting && e[0].boundingClientRect.top < 0); }).observe(box);
      sticky.addEventListener('click', function (e) { if (e.target.closest('[data-stk-cta]')) { var btn = root.querySelector('form button[type="submit"]'); if (btn) btn.click(); } });
    }
  }
  function boot() { document.querySelectorAll('[data-lp-buybox]').forEach(function (r) { try { bind(r); render(r); } catch (e) { console.warn('[lympha]', e); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.addEventListener('load', function () { boot(); setTimeout(boot, 600); });
  document.addEventListener('shopify:section:load', boot);
  // countdown bars
  function tick() {
    document.querySelectorAll('[data-lp-countdown]').forEach(function (el) {
      var end = new Date(el.dataset.lpCountdown).getTime(); if (isNaN(end)) return; var ms = end - Date.now();
      if (ms <= 0) { el.hidden = true; return; }
      var d = Math.floor(ms / 864e5), h = Math.floor(ms % 864e5 / 36e5), m = Math.floor(ms % 36e5 / 6e4);
      var q = function (s) { return el.querySelector(s); };
      if (q('[data-d]')) q('[data-d]').textContent = d; if (q('[data-h]')) q('[data-h]').textContent = ('0' + h).slice(-2); if (q('[data-m]')) q('[data-m]').textContent = ('0' + m).slice(-2);
    });
  }
  tick(); setInterval(tick, 1000);
})();
